<template>
    <div>
        <vs-popup :title="modelTitle" :active.sync="statusModelContactDetail" button-close-hidden>
            <div>
                <slot name="content"></slot>
            </div>
            <slot name="list_button">
                <div v-show="buttonTitleYes || buttonTitleNo" :class="[buttonTitleYes && buttonTitleNo ? 'flex justify-end' : 'flex justify-center', hasContentSlot ? 'mt-4' : '']">
                    <vs-button v-show="buttonTitleYes" color="success" class="mx-2" @click="$emit(eventEmitYes)">{{ buttonTitleYes }}</vs-button>
                    <vs-button v-show="buttonTitleNo" icon="cancel" color="lightgrey" @click="$emit(eventEmitNo)">{{ buttonTitleNo }}</vs-button>
                </div>
            </slot>
        </vs-popup>
    </div>
</template>
  
<script>
import EventBus from "../EventBus";
export default {
    data() {
        return {
            statusModelContactDetail: false,
        }
    },
    props: {
        activeModelCloseTab: {
            required: true,
            type: Boolean
        },
        modelTitle: {
            required: true,
            type: String
        },
        buttonTitleYes: {
            type: String
        },
        buttonTitleNo: {
            type: String
        },
        eventEmitYes: {
            type: String
        },
        eventEmitNo: {
            type: String
        }
    },
    computed: {
        hasContentSlot() {
            return this.$slots.content ? true : false
        }
    },
    watch: {
        activeModelCloseTab() {
            this.$nextTick(() => {
                this.statusModelContactDetail = this.activeModelCloseTab
            });
        },
        statusModelContactDetail(val) {
            this.$nextTick(() => {
                if(val == false) {
                    EventBus.$emit('disableModelPopupConfirm')
                }
            });
        } 
    }
}
</script>